
<template>
  <v-col class="d-flex hot-job-box flex-column pb-0" v-if="display">
    <v-row class="hot-job-img" justify="center">
      <img :src="'/briefcase.png'" alt="company-logo" />
    </v-row>
    <v-row class="flex-column hot-job-content">
      <v-col class="py-5 mt-2">
        <p class="display-28 mb-0 primary--text font-weight-medium">
          מעוניינים להוסיף כאן
          <br />
          משרה משלכם?
        </p>

        <v-btn
          outlined
          rounded
          color="black"
          class="mb-2 mt-3 job-btn font-weight-medium"
          :small="$vuetify.breakpoint.xs ? true : false"
          :href="`${adminUrl}`"
        >
          צרו איתנו קשר!
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    display: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    adminUrl() {
      return process.env.adminUrl;
    }
  }
};
</script>


<style lang="scss" scoped>
.hot-job-box {
  width: 100%;
  border: 1px solid #94acc0;
  border-radius: 5px;
  position: relative;
  text-align: center;
  box-shadow: inset 0 0 1px #f2f2f2;
  min-width: 220px;
  margin: 0 10px;
  @media only screen and (min-width: 700px) {
    max-width: 280px;
  }
  p.lightBlack--text {
    letter-spacing: -0.45px;
  }
}

.hot-job-img {
  background-color: #fff;

  margin-bottom: 2px;
  border-radius: 5px;
  padding: 14px 0;
  height: 70px;
  @media only screen and (min-width: 600px) {
    padding: 35px 0;
    height: 110px;
  }
  img {
    max-width: 130px;
    align-self: center;
    @media only screen and (min-width: 600px) {
    }
  }
}
.hot-job-content {
  background-color: #f2f3f5;
  border: 5px solid #fff;
  border-radius: 10px;
  height: 150px;
  @media only screen and (min-width: 600px) {
    height: 188px;
  }
}
.job-btn {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 180px;
  &:hover {
    background-color: $primary !important;
    color: white !important;
  }
  @media only screen and (min-width: 600px) {
    width: 200px;
    bottom: 20px;
  }
}
</style>
